import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const branchProductSlice = createSlice({
  name: "branchProduct",
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    },
    clearData: (state) => {
      state.data = [];
    },
  },
});

export const { setData, clearData } = branchProductSlice.actions;
export default branchProductSlice.reducer;
